<template>
  <v-layout
    fill-height
    column
    justify-start
    align-content-start
    style="width: 100%"
    class="scroll-fire-fox"
  >
  <div style="margin: 0px 15px 0px">

    <v-text-field
      v-model="search"
      prepend-inner-icon="search"
      :label="$t('Search')"
      :placeholder="$t('Search')"
      single-line
      class="layer-search"
    />
  </div>
    <div class="layers-tree scroll-fire-fox">
      <v-treeview
        open-on-click
        :items="layersMap"
        :search="search"
        item-key="id"
        item-text="label"
        return-object
        id="layers-right-sidebar-tree"
        :open="openMapLayer"
        @update:open="updateExpandedMapLayer"
        expand-icon="mdi-chevron-down"
        on-icon="mdi-checkbox-marked"
        off-icon="mdi-checkbox-blank-outline"
      >
        <template v-slot:prepend="{ item, open }">
          <v-checkbox
            :input-value="
              JSON.stringify(selectedMapLayer) === JSON.stringify(item)
            "
            v-if="!(item.label === 'Maps')"
            color="#767676"
            @change="updateSelectedLayersMap(item)"
          />
        </template>
        <template v-slot:label="{ item }">
          <div class="layer-item-label">
            {{ item.label }}
          </div>
        </template>
      </v-treeview>
      <v-treeview
        :value="tree"
        @input="updateSelectedLayers"
        :open="openLayers"
        @update:open="updateExpandedLayers"
        open-on-click
        :items="allLayers"
        :search="search"
        selectable
        item-key="id"
        item-text="label"
        return-object
        id="layers-right-sidebar-tree"
        expand-icon="mdi-chevron-down"
        on-icon="mdi-checkbox-marked"
        off-icon="mdi-checkbox-blank-outline"
      >
        <template v-slot:label="{ item }">
          <div class="layer-item-label">
            {{
              item.translatable_label
                ? $tc(item.translatable_label, 2)
                : item.label
            }}
          </div>
        </template>
        <template v-slot:append="{ item, selected }">
          <v-btn
            v-if="item.has_geoserver_label_button"
            @click="toggleGeoserverLabel(item)"
            icon
            text
            x-small
            class="ma-0"
            :disabled="!selected"
          >
            <v-icon
              v-if="item.has_geoserver_label_button"
              size="12"
              :color="
                isGeoserverLabelActive(item, selected)
                  ? 'accent'
                  : 'secondary darken-1'
              "
            >
              {{
                isGeoserverLabelActive(item, selected)
                  ? "mdi-tag"
                  : "mdi-tag-outline"
              }}
            </v-icon>
          </v-btn>

          <!-- <v-menu offset-y rounded="lg">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                text
                x-small
                class="ma-0"
                :disabled="item.has_geoserver_label_button ? false : true"
                @click.stop
               >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="!isGeoserverLabelActive(item, selected)">
                <v-list-item-title @click="toggleGeoserverLabel(item)">
                  <v-icon style="margin-right: 8px" color="#767676">
                    mdi-eye
                  </v-icon>
                  Show Label
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="isGeoserverLabelActive(item, selected)">
                <v-list-item-title @click="toggleGeoserverLabel(item)">
                  <v-icon style="margin-right: 8px" color="#767676">
                    mdi-eye-off
                  </v-icon>
                  Hide Label
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </template>
      </v-treeview>
    </div>
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  name: "RightSidebarLayers",

  data() {
    return {
      /**
       * Save the search value
       */
      search: "",

      allLayers: [],

      tree: [],
      defaultSelectedLayersCount: 0,
      loadedActiveLayers: false,

      openLayers: [],
      defaultExpandedLayersCount: 0,
      loadedExpandedLayers: false,

      activeGeoserverLabels: [],
      defaultActiveGeoserverLabelsCount: 0,
      loadedActiveGeoserverLabels: false,

      /**
       * Defines the map layers
       */
      layersMap: [],
      /**
       * Defines which map layer is selected
       */
      selectedMapLayer: {},
      openMapLayer: [],
      loadedExpandedMapLayer: false
    };
  },

  mounted() {
    this.initializeLayers();
  },

  methods: {
    ...mapActions(["getLayersMenu", "setActiveLayers","getConsumablesWMS"]),

    initializeLayers() {
      this.getAllLayers().then(() => {
        this.setOpenLayers();
        this.setSelectedLayers();
        this.setActiveGeoserverLabels();
        this.setSelectedMapLayers();
        this.setOpenMapLayers();
      });
    },

    isGeoserverLabelActive(layerLevel, selected) {
      if (layerLevel.layers.length > 0) {
        let layer = this.getLayerLevelLayerName(layerLevel);
        if (selected) {
          return this.activeGeoserverLabels.includes(layer);
        } else {
          let activeGeoserverLabelIndex = this.activeGeoserverLabels.findIndex(
            item => item === layer
          );
          if (activeGeoserverLabelIndex !== -1) {
            this.activeGeoserverLabels.splice(activeGeoserverLabelIndex, 1);
          }
          return false;
        }
      }
    },

    setActiveGeoserverLabels() {
      let activeGeoserverLabels = JSON.parse(
        sessionStorage.getItem("active_geoserver_labels")
      );
      if (activeGeoserverLabels) {
        this.activeGeoserverLabels = activeGeoserverLabels;
        this.loadedActiveGeoserverLabels = true;
      } else {
        for (const layer of this.allLayers) {
          this.setActiveGeoserverLabelsByDefault(layer, () => {
            this.loadedActiveGeoserverLabels = true;
            this.updateActiveGeoserverLabels();
          });
        }
      }
    },

    setActiveGeoserverLabelsByDefault(layerLevel, callback) {
      this.defaultActiveGeoserverLabelsCount++;
      if (
        layerLevel.has_geoserver_label_button &&
        layerLevel.geoserver_label_shown_default &&
        layerLevel.hasOwnProperty("selected_default") &&
        layerLevel.selected_default
      ) {
        let layer = this.getLayerLevelLayerName(layerLevel);
        this.activeGeoserverLabels.push(layer);
      }
      if (
        layerLevel.hasOwnProperty("children") &&
        layerLevel.children.length > 0
      ) {
        for (let child of layerLevel.children) {
          this.setActiveGeoserverLabelsByDefault(child, callback);
        }
      }
      this.defaultActiveGeoserverLabelsCount--;
      if (this.defaultActiveGeoserverLabelsCount === 0 && callback) {
        callback();
      }
    },

    getLayerLevelLayerName(layerLevel) {
      return layerLevel.layers[0].layer.layer;
    },

    toggleGeoserverLabel(layerLevel) {
      let layer = this.getLayerLevelLayerName(layerLevel);
      let activeGeoserverLabelIndex = this.activeGeoserverLabels.findIndex(
        item => item === layer
      );
      if (activeGeoserverLabelIndex !== -1) {
        this.activeGeoserverLabels.splice(activeGeoserverLabelIndex, 1);
      } else {
        this.activeGeoserverLabels.push(layer);
      }
      this.updateActiveGeoserverLabels();
    },

    /**
     * Get network layers
     */
    async getAllLayers() {
      try{
        const allLayers = await this.getLayersMenu("networkavailable");
        const WMSArray = await this.getWMS();
        /**
         * Separated the layer referring to the Map from the other layers.
         * It was necessary to separate it into different tree-selects,
         * because on the map you can only select one item
         */
        let indexLayerMap = allLayers.findIndex(
          layer => layer.label === "Maps"
        );
        let layerMap = [allLayers[indexLayerMap]];
        if(WMSArray){
          //add array of WMS to maps list
          WMSArray.forEach(element => {
            layerMap[0].children.push({
              label: element.code,
              id: element.id,
              url: element.url
            })
          });
        }
        allLayers.splice(indexLayerMap, 1);
        this.allLayers = allLayers;
        this.layersMap = layerMap;
      }catch(err){
        console.log(err);
      }
    },
    async getWMS(){
      try{
        const WMS = await this.getConsumablesWMS();
        return WMS;
      }catch(err){
        console.log(err)
      }
    },
    setOpenLayers() {
      let expandedSidebarLayers = JSON.parse(
        sessionStorage.getItem("network_expanded_layer_levels")
      );
      if (expandedSidebarLayers) {
        this.openLayers = expandedSidebarLayers;
        this.loadedExpandedLayers = true;
      } else {
        for (const layer of this.allLayers) {
          this.setLayersOpenByDefault(layer, () => {
            this.loadedExpandedLayers = true;
            this.updateExpandedLayers(this.openLayers);
          });
        }
      }
    },

    setLayersOpenByDefault(layerLevel, callback) {
      this.defaultExpandedLayersCount++;
      if (
        layerLevel.hasOwnProperty("expanded_default") &&
        layerLevel.expanded_default
      ) {
        this.openLayers.push(layerLevel);
      }
      if (
        layerLevel.hasOwnProperty("children") &&
        layerLevel.children.length > 0
      ) {
        for (const child of layerLevel.children) {
          this.setLayersOpenByDefault(child, callback);
        }
      }
      this.defaultExpandedLayersCount--;
      if (this.defaultExpandedLayersCount === 0 && callback) {
        callback();
      }
    },

    setSelectedLayers() {
      let selectedLayers = JSON.parse(
        sessionStorage.getItem("network_active_layers")
      );
      if (selectedLayers) {
        this.tree = selectedLayers;
        this.loadedActiveLayers = true;
      } else {
        for (const layer of this.allLayers) {
          this.setLayerSelectedByDefault(layer, () => {
            this.loadedActiveLayers = true;
            this.updateSelectedLayers(this.tree);
          });
        }
      }
    },

    setLayerSelectedByDefault(layerLevel, callback) {
      this.defaultSelectedLayersCount++;
      if (
        layerLevel.hasOwnProperty("selected_default") &&
        layerLevel.selected_default
      ) {
        this.tree.push(layerLevel);
      }
      if (
        layerLevel.hasOwnProperty("children") &&
        layerLevel.children.length > 0
      ) {
        for (let child of layerLevel.children) {
          this.setLayerSelectedByDefault(child, callback);
        }
      }
      this.defaultSelectedLayersCount--;
      if (this.defaultSelectedLayersCount === 0 && callback) {
        callback();
      }
    },

    updateSelectedLayers(layers) {
      if (this.loadedActiveLayers) {
        this.tree = layers;

        let activeLayers = [];
        for (const leaf of layers) {
          if (!leaf.hasOwnProperty("children") || leaf.children.length === 0) {
            activeLayers.push(leaf);
          }
        }
        sessionStorage.setItem(
          "network_active_layers",
          JSON.stringify(activeLayers)
        );

        this.emitSelectedLayers(activeLayers);
      }
    },

    emitSelectedLayers(activeLayers) {
      this.setActiveLayers(activeLayers);
      bus.$emit("update-geoserver-network-layers");
    },

    updateExpandedLayers(layersLevels) {
      if (this.loadedExpandedLayers) {
        this.openLayers = layersLevels;
        sessionStorage.setItem(
          "network_expanded_layer_levels",
          JSON.stringify(layersLevels)
        );
      }
    },

    /**
     * Update the selected map layer. When selecting a layer referring to the map,
     * it is necessary to issue an event to the map with the respective layer.
     * @param layer
     */
    updateSelectedLayersMap(layer) {
      if (this.selectedMapLayer.id === layer.id) {
        this.selectedMapLayer = {};
      } else {
        this.selectedMapLayer = layer;
      }
      sessionStorage.setItem(
        "active_network_layer_map",
        JSON.stringify(this.selectedMapLayer)
      );
      switch (this.selectedMapLayer.label) {
        case "Dark Map":
          /** Emits an event to set the map to dark mode **/
          this.$store.dispatch("SET_MAP_STYLE", "dark-map");
          bus.$emit("change-map-network", "roadMapLayer");
          break;
        case "Light Map":
          /** Emits an event to set the map to light mode **/
          this.$store.dispatch("SET_MAP_STYLE", "light-map");
          bus.$emit("change-map-network", "roadMapLayer");
          break;
        case "Default Satellite":
          bus.$emit("change-map-network", "aerialMapLayer");
          break;
        case "Open Street Map":
          bus.$emit("change-map-network", "openStreetMap");
          break;
        default:
          bus.$emit("change-map-network", "newLayer");
          break;
      }
    },

    /**
     * Define which map layers are selected.
     * If there is a layer in sessionStorage, that same layer is selected.
     * If not, select the layer in which the value of the variable 'selected_default' is true
     */
    setSelectedMapLayers() {
      let selectedLayer = JSON.parse(
        sessionStorage.getItem("active_network_layer_map")
      );

      if (selectedLayer) {
        this.selectedMapLayer = selectedLayer;
      } else {
        for (const layer of this.layersMap) {
          for (const layerMap of layer.children) {
            if (
              layerMap.hasOwnProperty("selected_default") &&
              layerMap.selected_default
            ) {
              this.updateSelectedLayersMap(layerMap);
            }
          }
        }
      }
    },

    /**
     * Set whether the map layer is expanded.
     * If in sessionStorage there is a layer, the map layer is expanded
     */
    setOpenMapLayers() {
      let expandedSidebarLayers = JSON.parse(
        sessionStorage.getItem("expanded_map_layer_levels")
      );
      if (expandedSidebarLayers) {
        this.openMapLayer = expandedSidebarLayers;
      }
      this.loadedExpandedMapLayer = true;
    },

    /**
     * Update expanded map layer
     * @param layer
     */
    updateExpandedMapLayer(layer) {
      if (this.loadedExpandedMapLayer) {
        this.openMapLayer = layer;
        sessionStorage.setItem(
          "expanded_map_layer_levels",
          JSON.stringify(layer)
        );
      }
    }
  }
};
</script>

<style scoped>
.layers-search {
  font-size: 12px;
  flex: unset;
  height: 30px;
  border-radius: unset;
}

.layers-tree {
  width: 100%;
  height: calc(100% - 140px);
  overflow: auto;
  padding: 6px !important;
}

.layer-item-label {
  color: #767676;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400; 
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.0616822px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.layers-search .v-input__slot {
  min-height: 0 !important;
}

.layers-search .v-label {
  top: 4px !important;
  font: normal normal normal 12px/16px Segoe UI;
  color: #b1b6b9;
}

#layers-right-sidebar-tree .v-treeview-node__prepend {
  margin-right: 0 !important;
}

#layers-right-sidebar-tree .v-treeview-node__content {
  margin-left: 0 !important;
}

#layers-right-sidebar-tree .v-treeview-node__root {
  min-height: 34px !important;
  padding: 0 !important;
}

.layer-title.theme--light.v-input--is-disabled {
  background-color: #fff !important;
  color: #767676 !important;
}

#layers-right-sidebar-tree .v-treeview-node__checkbox {
  color: #767676 !important;
  font-size: 18px;
  margin-left: 0 !important;
}

#layers-sidebar-tree .v-icon.v-icon {
  color: #767676 !important;
  font-size: 18px;
  margin-left: 0 !important;
  height: 100% !important;
  width: 18px !important;
}

#layers-right-sidebar-tree .v-icon.v-icon:after {
  background-color: transparent !important;
}

#layers-right-sidebar-tree .v-treeview-node__prepend {
  min-width: unset !important;
  margin: 0 !important;
}
#layers-right-sidebar-tree .v-input--selection-controls__input,
#layers-right-sidebar-tree .v-input--selection-controls,
#layers-right-sidebar-tree .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
}

#layers-right-sidebar-tree .v-input--selection-controls__input {
  height: unset !important;
}

.layer-search {
  flex: 0 0 auto;
  width: 100%;
  font-size: 12px;
}
</style>

<style scoped>
.theme--light.v-input--is-disabled >>> input,
.theme--light.v-input--is-disabled >>> textarea {
  background-color: #fff !important;
  color: #767676 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/RightSidebar/RightSidebarLayers.vue